import PropTypes from 'prop-types';
import { Flex, Text } from '../../../../../ui-kit';
import * as COPY from '../utilities/copy';
import AlertSuccessIcon from '../../../../../ui-kit/icons/AlertSuccessIcon';
import { editCopyByReplaceString } from '../../../../../utilities/copyFunctions';
import { SummaryContent } from '../../../Content';

const propTypes = {
  /** Title of the suite */
  suiteTitle: PropTypes.string.isRequired,

  /** Total for the suite */
  suiteTotal: PropTypes.number.isRequired,

  /** Promo code used in the reservation */
  promoCode: PropTypes.string,

  /** Number of guests as `1 Adult, 0 Kid` or `2 Adults, 2 Kids` */
  guestCountText: PropTypes.string.isRequired,

  /** Number of new guests added from CMP */
  newCMPGuestsCount: PropTypes.object,

  /** Splash text for the tag next to the guest count, when the reservation has new guests */
  guestSplash: PropTypes.string
};

export const SuiteDetails = ({
  suiteTitle,
  suiteName,
  suiteTotal,
  guestCountText,
  promoCode,
  newCMPGuestsCount,
  isDynamicOfferCode,
  guestSplash
}) => {
  const newGuestsWithFeeTotal = () => {
    return newCMPGuestsCount?.feeGuests > 0
      ? `$${(newCMPGuestsCount?.feeGuests * newCMPGuestsCount?.extraPerGuestAmount).toFixed(2)}`
      : `$0.00`;
  };
  return (
    <>
      <SummaryContent.Divider borderThickness={2} />
      <SummaryContent.Item fontWeight="bold" mb={8}>
        <SummaryContent.Description>
          <Text fontSize={0} lineHeight={16}>
            {suiteName ?? suiteTitle}
          </Text>
        </SummaryContent.Description>
        <SummaryContent.SubtotalAmount>
          <Text fontSize={0} lineHeight={16}>
            {`$${
              newCMPGuestsCount?.feeGuests > 0
                ? (suiteTotal - newCMPGuestsCount?.feeGuests * newCMPGuestsCount?.extraPerGuestAmount).toFixed(2)
                : suiteTotal.toFixed(2)
            }`}
          </Text>
        </SummaryContent.SubtotalAmount>
      </SummaryContent.Item>

      {newCMPGuestsCount?.unbillableGuests > 0 ? (
        <>
          <SummaryContent.Item fontWeight="bold" mb={8}>
            <SummaryContent.Description>
              <Text fontSize={0} lineHeight={18}>
                {editCopyByReplaceString(
                  COPY.NEW_GUESTS_ADDED,
                  String(newCMPGuestsCount?.unbillableGuests),
                  '<GUEST_COUNT>'
                )}
              </Text>
            </SummaryContent.Description>
            <SummaryContent.SubtotalAmount>
              <Text fontSize={0} lineHeight={16}>{`$0.00`}</Text>
            </SummaryContent.SubtotalAmount>
          </SummaryContent.Item>
          <SummaryContent.Item>
            <SummaryContent.Description>
              <Text color="nightSkyBlack.80" fontSize={0} lineHeight={18}>
                {COPY.NEW_GUESTS_IN_BASE_OCUPANCY}
              </Text>
            </SummaryContent.Description>
          </SummaryContent.Item>
        </>
      ) : null}
      {newCMPGuestsCount?.feeGuests > 0 ? (
        <>
          <SummaryContent.Item fontWeight="bold" mb={8}>
            <SummaryContent.Description>
              <Text fontSize={0} lineHeight={18}>
                {editCopyByReplaceString(COPY.NEW_GUESTS_ADDED, String(newCMPGuestsCount?.feeGuests), '<GUEST_COUNT>')}
              </Text>
            </SummaryContent.Description>
            <SummaryContent.SubtotalAmount>
              <Text fontSize={0} lineHeight={16}>
                {newGuestsWithFeeTotal()}
              </Text>
            </SummaryContent.SubtotalAmount>
          </SummaryContent.Item>
          <SummaryContent.Item>
            <SummaryContent.Description>
              <Text color="nightSkyBlack.80" fontSize={0} lineHeight={18}>
                {COPY.NEW_GUESTS_IN_MAX_OCUPANCY}
              </Text>
            </SummaryContent.Description>
          </SummaryContent.Item>
        </>
      ) : null}

      <SummaryContent.Item>
        <SummaryContent.Description>
          <Text fontSize={0} lineHeight={18}>
            <Flex>
              {guestCountText}
              {guestSplash ? <SummaryContent.NewGuestsTag splashText={guestSplash} /> : null}
            </Flex>
          </Text>
        </SummaryContent.Description>
      </SummaryContent.Item>
      {promoCode ? (
        <SummaryContent.Item fontWeight="bold" color="successGreen">
          <SummaryContent.Description>
            <Text color="deepForestGreen.100" fontSize={0} lineHeight={16}>
              {isDynamicOfferCode
                ? COPY.SUMMARY_HIDDEN_CODE_APPLIED
                : editCopyByReplaceString(COPY.SUMMARY_CODE_APPLIED, promoCode, '<CODE>')}
            </Text>
          </SummaryContent.Description>
          <AlertSuccessIcon size="21px" />
        </SummaryContent.Item>
      ) : null}
    </>
  );
};

SuiteDetails.propTypes = propTypes;

SuiteDetails.defaultProps = {
  iconSize: 16
};
